import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Product } from 'src/app/pages/models/type/product.model';
import firebase from '@firebase/app-compat';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  constructor(private firestore: AngularFirestore) {}

  getPoducts() {
    return this.firestore.collection('Products').snapshotChanges();
  }

  getStorePoducts(ownerID) {
    return this.firestore
      .collection('Products', (ref) => ref.where('storeID', '==', ownerID))
      .snapshotChanges();
  }

  getProduct(id) {
    return this.firestore.collection('Products').doc(id).get();
  }

  addProduct(product) {
    const id = this.firestore.createId();
    const createdAt = firebase.firestore.FieldValue.serverTimestamp();
    return this.firestore
      .collection('Products')
      .doc(id)
      .set({
        ...product,
        id,
      });
  }
}
